// GENERATED by tools/stage_web_emotes.py - DO NOT EDIT.
//
// The one map of what emotes exist. Hand-writing this list is how a set drifts from
// the files on disk and a button renders a 404.
//
// ⚠️ These are STILLS, not animations. The animated sheets are the previous studio's
// art and are never shipped - see the stager's header.

export interface EmoteDef {
  /** Stable key, exactly as the file is named on disk. An address, never a label. */
  readonly expr: string;
  /** What the player reads. Ours. */
  readonly label: string;
  readonly url: string;
}

export const EMOTE_CHARACTERS = ["Charon", "Chttonius", "FaeFox", "Tomyios", "Wolfshadow"] as const;

export const EMOTES: Readonly<Record<string, readonly EmoteDef[]>> = Object.freeze({
  "Charon": Object.freeze([
    { expr: "Hi", label: "Howdy", url: "/art/emotes/charon_hi.png" },
    { expr: "WellDone", label: "Well played", url: "/art/emotes/charon_welldone.png" },
    { expr: "LOL", label: "Ha!", url: "/art/emotes/charon_lol.png" },
    { expr: "Victory", label: "Yeehaw", url: "/art/emotes/charon_victory.png" },
    { expr: "Thinking", label: "Thinking", url: "/art/emotes/charon_thinking.png" },
    { expr: "SmartFace", label: "Figures", url: "/art/emotes/charon_smartface.png" },
    { expr: "Shocking", label: "Well I never", url: "/art/emotes/charon_shocking.png" },
    { expr: "Love", label: "Much obliged", url: "/art/emotes/charon_love.png" },
    { expr: "Love", label: "Much obliged", url: "/art/emotes/charon_love.png" },
    { expr: "Cry", label: "Sorry", url: "/art/emotes/charon_cry.png" },
    { expr: "Angry", label: "Angry", url: "/art/emotes/charon_angry.png" },
    { expr: "EvilEye", label: "Watch it", url: "/art/emotes/charon_evileye.png" },
  ]),
  "Chttonius": Object.freeze([
    { expr: "Hello", label: "Howdy", url: "/art/emotes/chttonius_hello.png" },
    { expr: "SFWH", label: "Good luck", url: "/art/emotes/chttonius_sfwh.png" },
    { expr: "WellPlayed", label: "Well played", url: "/art/emotes/chttonius_wellplayed.png" },
    { expr: "Laugh", label: "Ha!", url: "/art/emotes/chttonius_laugh.png" },
    { expr: "Victory", label: "Yeehaw", url: "/art/emotes/chttonius_victory.png" },
    { expr: "SmartFace", label: "Figures", url: "/art/emotes/chttonius_smartface.png" },
    { expr: "Shocking", label: "Well I never", url: "/art/emotes/chttonius_shocking.png" },
    { expr: "LoveEyes", label: "Much obliged", url: "/art/emotes/chttonius_loveeyes.png" },
    { expr: "Cry", label: "Sorry", url: "/art/emotes/chttonius_cry.png" },
    { expr: "Angry", label: "Angry", url: "/art/emotes/chttonius_angry.png" },
    { expr: "EvilEye", label: "Watch it", url: "/art/emotes/chttonius_evileye.png" },
    { expr: "Confused", label: "Confused", url: "/art/emotes/chttonius_confused.png" },
  ]),
  "FaeFox": Object.freeze([
    { expr: "Hello", label: "Howdy", url: "/art/emotes/faefox_hello.png" },
    { expr: "SFWH", label: "Good luck", url: "/art/emotes/faefox_sfwh.png" },
    { expr: "WellPlayed", label: "Well played", url: "/art/emotes/faefox_wellplayed.png" },
    { expr: "LOL", label: "Ha!", url: "/art/emotes/faefox_lol.png" },
    { expr: "Victory", label: "Yeehaw", url: "/art/emotes/faefox_victory.png" },
    { expr: "SmartFace", label: "Figures", url: "/art/emotes/faefox_smartface.png" },
    { expr: "Shocked", label: "Well I never", url: "/art/emotes/faefox_shocked.png" },
    { expr: "LoveEyes", label: "Much obliged", url: "/art/emotes/faefox_loveeyes.png" },
    { expr: "Cry", label: "Sorry", url: "/art/emotes/faefox_cry.png" },
    { expr: "Angry", label: "Angry", url: "/art/emotes/faefox_angry.png" },
    { expr: "EvilSmile", label: "Watch it", url: "/art/emotes/faefox_evilsmile.png" },
    { expr: "Confused", label: "Confused", url: "/art/emotes/faefox_confused.png" },
  ]),
  "Tomyios": Object.freeze([
    { expr: "Hello", label: "Howdy", url: "/art/emotes/tomyios_hello.png" },
    { expr: "SWFH", label: "Good luck", url: "/art/emotes/tomyios_swfh.png" },
    { expr: "WellPlayed", label: "Well played", url: "/art/emotes/tomyios_wellplayed.png" },
    { expr: "LOL", label: "Ha!", url: "/art/emotes/tomyios_lol.png" },
    { expr: "Victory", label: "Yeehaw", url: "/art/emotes/tomyios_victory.png" },
    { expr: "Thinking", label: "Thinking", url: "/art/emotes/tomyios_thinking.png" },
    { expr: "SmartFace", label: "Figures", url: "/art/emotes/tomyios_smartface.png" },
    { expr: "Shocked", label: "Well I never", url: "/art/emotes/tomyios_shocked.png" },
    { expr: "LoveEyes", label: "Much obliged", url: "/art/emotes/tomyios_loveeyes.png" },
    { expr: "Cry", label: "Sorry", url: "/art/emotes/tomyios_cry.png" },
    { expr: "Angry", label: "Angry", url: "/art/emotes/tomyios_angry.png" },
    { expr: "EvilEye", label: "Watch it", url: "/art/emotes/tomyios_evileye.png" },
  ]),
  "Wolfshadow": Object.freeze([
    { expr: "Hi", label: "Howdy", url: "/art/emotes/wolfshadow_hi.png" },
    { expr: "GLHF", label: "Good luck", url: "/art/emotes/wolfshadow_glhf.png" },
    { expr: "SFWH", label: "Good luck", url: "/art/emotes/wolfshadow_sfwh.png" },
    { expr: "WellDone", label: "Well played", url: "/art/emotes/wolfshadow_welldone.png" },
    { expr: "LOL", label: "Ha!", url: "/art/emotes/wolfshadow_lol.png" },
    { expr: "SmartFace", label: "Figures", url: "/art/emotes/wolfshadow_smartface.png" },
    { expr: "Shocked", label: "Well I never", url: "/art/emotes/wolfshadow_shocked.png" },
    { expr: "LoveEyes", label: "Much obliged", url: "/art/emotes/wolfshadow_loveeyes.png" },
    { expr: "Cry", label: "Sorry", url: "/art/emotes/wolfshadow_cry.png" },
    { expr: "Angry", label: "Angry", url: "/art/emotes/wolfshadow_angry.png" },
    { expr: "EvilEye", label: "Watch it", url: "/art/emotes/wolfshadow_evileye.png" },
    { expr: "Confused", label: "Confused", url: "/art/emotes/wolfshadow_confused.png" },
  ]),
});

/**
 * ⭐ THE DEFAULT SET. Charon is the ferryman of the dead, and the card the original
 * summoned from him is our `Avatar of the Last Crossing` - the Last Crossing IS his
 * ferry, so the lore already agrees with itself. Used until emotes are per-hero.
 */
export const DEFAULT_EMOTE_CHARACTER = "Charon";
